import cookie from 'cookie';
import { jwtDecode } from 'jwt-decode';

import React from 'react';
import { render } from 'react-dom';
import { HashRouter as Router } from 'react-router-dom'; // Ensure Router is used
import { ThemeProvider } from 'react-jss';
import theme from 'config/theme';
import { SelectedOffersProvider } from './SelectedOffersContext';
import App from './components/App/index';

import { UserProvider } from './UserContext';

let decodedToken = null;

if (window.location.hostname !== 'localhost') {
  const cookies = cookie.parse(document.cookie);
  if (!cookies.pricelist) {
    window.location = 'https://qdt.qlik.com/api/pricelist/auth/saml/login';
  } else {
    decodedToken = jwtDecode(cookies.pricelist);
  }
}

const defaultTheme = {
  container: {
    padding: '20px',
    margin: '0 auto',
  },
  colors: {
    primary: '#0078d7',
    secondary: '#005a9e',
    background: '#ffffff',
    text: '#333333',
  },
};

render(
  <ThemeProvider theme={theme || defaultTheme}>
    <SelectedOffersProvider>
      <UserProvider value={decodedToken}>
        <Router>
          <App />
        </Router>
      </UserProvider>
    </SelectedOffersProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);
